import { TYPES } from '@Types';
import { RequestFailure } from '@Repository/RequestAction';
import {
  ModelRuleRepository,
  RequestModelRulesSuccess,
} from '@Repository/ninthAge';
import { inject, injectable } from 'inversify';
import { Result } from '@Redux/type';
import { change, formValueSelector } from 'redux-form';

@injectable()
export class ModelRulesAction {
  @inject(TYPES.Repository.ModelRuleRepository)
  private _repository!: ModelRuleRepository;

  public search =
    ({
      versionId,
      armyIds,
      locale,
    }: {
      versionId?: number;
      armyIds?: Array<number>;
      locale?: string;
    }): Result<void> =>
    async (dispatch, getState) => {
      const selector = formValueSelector('search_special_rule');

      const response = await this._repository.seach({
        versionId: versionId ?? selector(getState(), 'versionId'),
        armyIds: armyIds ?? selector(getState(), 'armyIds'),
        locale: locale ?? null,
      });

      if (response instanceof RequestFailure) {
        dispatch(change('search_special_rule', 'rules', []));
        return;
      }

      const success = response as RequestModelRulesSuccess;
      dispatch(change('search_special_rule', 'rules', success.payload));
    };
}
